import dayjs, { Dayjs } from "dayjs";
import { FeatureCollection } from "geojson";
import mapboxgl from "mapbox-gl";
import { useRef, useState } from "react";
import { MapRef } from "react-map-gl/mapbox";
import { Area } from "../models/Area";
import { Equipment } from "../models/Equipment";
import { MapObject } from "../models/MapObject";
import { WaypointStep } from "../models/WaypointStep";

interface useMapInfoProps {
    mapObjectsByProject: any;
    mapObjectsForProject: (projectToken: string) => MapObject[];
    projectInfo: any;
}

const useMappables = (props: useMapInfoProps) => {
    const mapRef = useRef<MapRef>(null);
    const [mapGeoJson, setMapGeoJson] = useState<FeatureCollection | null>(null);
    const [mapBoxDraw, setMapBoxDraw] = useState<any>(null);
    const mapPopup = new mapboxgl.Popup({
        maxWidth: "50%",
        closeButton: false,
        closeOnClick: false,
    });
    const [currentMappable, setCurrentMappable] = useState<Area | Equipment | null>(null);
    const [currentMapObject, setCurrentMapObject] = useState<MapObject | null>(null);
    const [editCurrentMappable, setEditCurrentMappable] = useState<boolean>(false);
    const [newMappableType, setNewMappableType] = useState<"area" | "equipment" | null>(null);
    const [editCurrentMappablePosition, setEditCurrentMappablePosition] = useState<boolean>(false);
    const [mapFilterDate, setMapFilterDate] = useState<Dayjs | null>(dayjs());
    const [currentWaypointStep, setCurrentWaypointStep] = useState<WaypointStep | null>(null);
    const mapBounds = new mapboxgl.LngLatBounds();
    const [userLocation, setUserLocation] = useState<GeolocationCoordinates | null>(null);
    const geoControlRef = useRef<mapboxgl.GeolocateControl>(null);
    const [waypointGuidance, setWaypointGuidance] = useState<boolean>(false);

    return {
        mapRef,

        mapGeoJson,
        setMapGeoJson,

        mapPopup,

        mapBoxDraw,
        setMapBoxDraw,

        currentMappable,
        setCurrentMappable,

        currentMapObject,
        setCurrentMapObject,

        editCurrentMappable,
        setEditCurrentMappable,

        newMappableType,
        setNewMappableType,

        editCurrentMappablePosition,
        setEditCurrentMappablePosition,

        mapFilterDate,
        setMapFilterDate,

        currentWaypointStep,
        setCurrentWaypointStep,

        mapBounds,

        userLocation,
        setUserLocation,

        geoControlRef,

        waypointGuidance,
        setWaypointGuidance,
    };
};

export default useMappables;
